import React, { useEffect, useState } from "react";
import PartnerMenu from "../layouts/partner_sidemenu";
import PartneHeader from "../layouts/partner_header";
import DashboardFooter from "../../institutions/layouts/dashboard_footer";
import Canvas from "../../institutions/layouts/dahboard_canvas";
import axios from "axios";

interface Spec {
  id: number;
  name: string;
  descr: string;
}

interface Subcat {
  id: number;
  name: string;
  slug: string;
  descr: string;
  specs: Spec[];
}

interface Category {
  id: number;
  name: string;
  slug: string;
  descr: string;
  subcats: Subcat[];
}

const ProfessionDirectory: React.FC = () => {
  const baseUrl = (import.meta as any).env?.VITE_API_URL || (process as any).env?.REACT_APP_API_URL || "http://64.227.174.0:8004";

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(`${baseUrl}/facilities/categories-with-slugs`);
        if (res.data?.status === "success") {
          if (isMounted) setCategories(res.data.data as Category[]);
        } else {
          if (isMounted) setError(res.data?.message || "Failed to load categories");
        }
      } catch (e: any) {
        if (isMounted) setError(e?.message || "Network error");
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [baseUrl]);

  const partnerName: any = "";
  const partnerId: any = "";
  const partnerCat: any = "";
  const partnerLogo: any = "";

  return (
    <>
      <PartneHeader partner_name={partnerName} partner_id={partnerId} partner_cat={partnerCat} partner_logo={partnerLogo} />
      <PartnerMenu />

      <div className="vertical-overlay"></div>

      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Profession Directory</h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><a href="/partner/home">Partner</a></li>
                      <li className="breadcrumb-item active">Professions</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            {loading && (
              <div className="alert alert-info">Loading professions...</div>
            )}
            {error && (
              <div className="alert alert-danger">{error}</div>
            )}

            {!loading && !error && (
              <div className="row">
                {categories.map((cat) => (
                  <div className="col-12 col-md-6 col-lg-4 mb-3" key={cat.id}>
                    <div className="card card-animate h-100">
                      <div className="card-body">
                        <h5 className="card-title mb-2">
                          <a href={`/partner/${cat.slug}/home`} className="text-decoration-none">{cat.name}</a>
                        </h5>
                        <p className="text-muted mb-3" style={{minHeight: 40}}>{cat.descr}</p>
                        {cat.subcats?.length > 0 && (
                          <div>
                            <div className="fw-semibold mb-1">Subcategories</div>
                            <ul className="list-unstyled mb-0">
                              {cat.subcats.slice(0, 4).map((sc) => (
                                <li key={sc.id}>
                                  <small className="text-muted">{sc.name}</small>
                                </li>
                              ))}
                              {cat.subcats.length > 4 && (
                                <li><small className="text-muted">and more...</small></li>
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                      <div className="card-footer d-flex justify-content-end">
                        <a className="btn btn-sm btn-primary" href={`/partner/${cat.slug}/home`}>Open</a>
                      </div>
                    </div>
                  </div>
                ))}
                {categories.length === 0 && (
                  <div className="col-12">
                    <div className="alert alert-warning">No professions available.</div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <DashboardFooter />
      </div>

      <Canvas />
    </>
  );
};

export default ProfessionDirectory;
